import smartSolveApi from './instances/smartsolve';

export const getDataValueLookup = async (tableName, fieldName) => {
  try {
    const response = await smartSolveApi.post('/datavaluelookup', {
      tableName,
      fieldName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getDataValueLookup failed: ${e}`);
  }
};
